<template>
<div id="more-detail" v-if="detailShow">
  <div class="top">
    <a @click="goBack">
      <img src="../../assets/icon/iamge_nav_cancel@3x.png" alt="">
    </a>
    <h1>Notice</h1>
  </div>

  <div class="title clearfix">
    <img src="../../assets/icon/image_faq_detail@3x.png" alt="">
    <h3>{{contentData.title}}</h3>
  </div>
  <div class="bottom">
    <p>Switch Off the "Private Account" in the Settings of Instagram app.</p>
    <img src="../../assets/icon/image_private_guide@3x.png" alt="">
    <p>Your posts will receive likes and views only when your account is public. So you need to make sure you aren't using a private profile.</p>
  </div>
</div>
</template>

<script>




export default {
  components: {

  },
  mounted(){

  },
  computed:{
    detailShow(){
      return this.$store.state.web_login_detail_show
    }
  },
  data() {
    return {
      contentData:
      {
        "title":"Make sure you aren't using a private profile ",
        "content":"Tap on the username on the top bar."
      }
    }
  },
  methods: {
    goBack(){
      this.$store.commit("updateLoginDetailShow",{
        "web_login_detail_show":false
      })
    }
    }
}
</script>

<style lang="less" scoped>
#more-detail{
  background: #FFF;
  position: fixed;
  z-index: 501;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
    .top{
      width: 100%;
    height: 40px;
    background: linear-gradient(to right, #1e2022, #414449);
    // position: fixed;
    // top: 0;
    // left: 0;
    z-index: 1000;
    h1{
      text-align: center;
      color: #FFF;
      font-size: 15px;
      line-height: 40px;
      font-weight: bold;
    }
    a{
      display: block;
      width: 44px;
      height: 40px;
      position: absolute;
      left: 3px;
      top: 0;
      img{
        display: block;
        width: 22px;
        height: auto;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%,-50%);
      }
    }
}
  .title{
    display: flex;
    align-items: flex-start;
    border-bottom: 0.5px solid rgb(215,215,215);
    padding: 20px 15px 20px 15px;

    h3{
      font-size: 16px;
      color: rgb(23,22,22);
      line-height: 19px;
      font-weight: bold;
    }
    img{
      display: block;
      width: 22px;
      height: auto;
      margin-right: 10px;
    }
  }
  .bottom{
    padding: 20px 15px;
    overflow: scroll;
    img{
      display: block;
      width: 100%;
      margin: 0 auto;
      // margin-bottom: 26px;
      margin-top: 4px;
    }
    p{
      font-size: 16px;
      color: rgb(23,22,22);
      line-height: 19px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// LoginDetail.vue?4bd0dd55